import { render, staticRenderFns } from "./Viewpoints.vue?vue&type=template&id=5672770a&"
import script from "./Viewpoints.vue?vue&type=script&lang=js&"
export * from "./Viewpoints.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports